import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

function Delivery() {

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  return (
    <div className="page container">

       <Helmet>
        <title>Fast Delivery | realgeneric shop</title>
        <meta
          name="description"
          content="Get your medicines delivered fast and discreetly worldwide with Realgenericshop's secure shipping process."
        />
        <link rel="canonical" href="https://realgenericshop.com/delivery" />
      </Helmet>

      <h1>Fast Delivery – Get Your Medicines Quickly and Discreetly</h1>

      <p>
        At <b>Realgenericshop</b>, we understand that timely access to medicines matters.
        That’s why we offer fast delivery worldwide, ensuring you never miss a dose.
      </p>

      <p>
        We equally value your privacy and safety. Every order is packed in discreet packaging,
        meaning there are no outside labels or markings indicating its contents.
        It also includes tamper-proof seals to ensure your medicines remain safe and confidential
        until they reach you.
      </p>

      <h3>Why Choose Realgenericshop?</h3>

      <p>
        We believe packaging isn’t just about wrapping your order; it’s about protection,
        privacy, and reliability. Therefore, we offer:
      </p>

      <h4>Wide range of affordable products</h4>
      <p>
        450+ generic and branded medicines are available. Our pricing ensures savings up to 80%
        compared to standard US prices.
      </p>

      <h4>Swift processing & dispatch</h4>
      <p>
        Orders are usually processed within 48 hours of confirmation.
        Early dispatch helps minimize delivery timelines and avoids delays.
      </p>

      <h4>Tamper-proof protection</h4>
      <p>
        Packaging is designed to protect medicines from damage, heat, light, humidity,
        and rough handling. Each package includes a tamper-proof seal ensuring safety and integrity.
      </p>

      <h4>Discreet packaging for privacy</h4>
      <p>
        Orders are shipped in plain, unbranded packaging with no mention of medicine names or health details.
        This ensures complete confidentiality.
      </p>

      <h4>Reliable global shipping partners</h4>
      <p>
        We work with trusted international logistics providers to ensure timely worldwide delivery.
        However, occasional delays may occur due to customs or weather conditions.
      </p>

      <p>
        Delivery estimates: 2–3 weeks for the US, and 3–4 weeks for other regions worldwide.
      </p>

      <h4>Trackable shipments for transparency</h4>
      <p>
        Every order is assigned a unique tracking ID sent via email after dispatch.
        Customers can track real-time updates through the Track Order page.
      </p>

      <p>
        For any help or queries, contact us at support@realgenericshop.com.
      </p>

      <h3>How Does Our Packaging, Shipping & Delivery Process Work?</h3>

      <p>
        Once you place your order, our team verifies it. After verification and payment,
        medicines are packed under the supervision of a qualified pharmacist in secure boxes
        to protect them from damage, moisture, and tampering during transit.
      </p>

      <p>
        Tracking IDs are shared via email once the order is shipped.
        Please note tracking may take up to 48 hours to become active.
      </p>

      <p>
        US orders are usually delivered within 2–3 weeks depending on shipping method.
        Other regions may take 3–4 weeks. You can track your order online anytime.
      </p>

      <h3>Customer Delivery Assurance Guarantee</h3>

      <p>
        Every medicine is shipped with care and responsibility. Whether it’s for general wellness
        or specific needs, you can rely on Realgenericshop for fast delivery, discreet packaging,
        and dependable service every time.
      </p>

      <h3>FAQs</h3>

      <h4>How fast is your delivery?</h4>
      <p>
        Most US orders are delivered within 2–3 weeks. Other regions may take 3–4 weeks.
        Delays may occur due to customs or external factors.
      </p>

      <h4>Is the packaging discreet?</h4>
      <p>
        Yes. All orders are shipped in plain packaging with no external indication of contents.
      </p>

      <h4>Do you provide secure packaging for all orders?</h4>
      <p>
        Yes. Every order is securely packed regardless of size or type.
      </p>

      <h4>Can I track my order?</h4>
      <p>
        Yes. After shipping, you will receive a tracking ID via email or SMS to monitor delivery status.
      </p>

      <h4>Do you ship internationally?</h4>
      <p>
        Yes. We deliver globally using trusted logistics partners.
      </p>

    </div>
  );
}

export default Delivery;